import {
  Typography,
  Box,
  Container,
  Grid,
  Link as MuiLink,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import {
  PUBLIC_INFO_EMAIL,
  publicAiPhoneDisplay,
  publicAiPhoneTelHref,
  publicInfoMailtoHref,
} from "../constants/publicContact";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "#f1f5f9",
        color: "#333",
        py: 3,
        borderTop: "1px solid #e2e8f0",
        fontFamily: "Poppins, sans-serif",
      }}
      >
        <Container>
          <Grid container justifyContent={"space-between"}>
            <Grid item size={{ xs: 12, md: 4 }} md={4} mb={2}>
              <Typography variant="h6" fontWeight={600} textAlign={"center"}>
                Autoshops.com
              </Typography>
              <Typography variant="body1" textAlign={"center"}>
                Connecting Car Owners with Local Autoshops.
              </Typography>
            </Grid>
          {/* ✅ Middle Section (Company links) */}
          <Grid item xs={12} md={4} sx={{ mb: 2 }}>
            <Typography variant="h6" fontWeight={600} textAlign="center">
              Company
            </Typography>
            <Typography variant="body1" textAlign="center">
              <MuiLink
                component={RouterLink}
                to="/about"
                underline="hover"
                color="inherit"
              >
                About Us
              </MuiLink>
            </Typography>
          </Grid>

          {/* ✅ Right Section (Support links) */}
          <Grid item xs={12} md={4} sx={{ mb: 2 }}>
            <Typography variant="h6" fontWeight={600} textAlign="center">
              Support
            </Typography>
            <Typography variant="body1" textAlign="center">
              <MuiLink
                component={RouterLink}
                to="/contact"
                underline="hover"
                color="inherit"
              >
                Contact
              </MuiLink>
            </Typography>
            <Typography variant="body2" textAlign="center" sx={{ mt: 0.5 }}>
              <MuiLink href={publicInfoMailtoHref()} underline="hover" color="inherit">
                {PUBLIC_INFO_EMAIL}
              </MuiLink>
            </Typography>
            <Typography variant="body2" textAlign="center">
              <MuiLink
                href={`tel:${publicAiPhoneTelHref()}`}
                underline="hover"
                color="inherit"
              >
                Phone {publicAiPhoneDisplay()}
              </MuiLink>
            </Typography>
          </Grid>

          {/* ❌ Newsletter section kept commented out for later use */}
          {/*
          <Grid item xs={12} md={3}>
            <Typography variant="h6" fontWeight={600}>
              Stay Updated
            </Typography>
            <Typography variant="body1">
              Subscribe to our newsletter
            </Typography>
            <Box
              component="form"
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 1,
                mt: 1,
              }}
            >
              <input
                type="email"
                placeholder="Your email"
                aria-label="Email address"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  fontSize: "1rem",
                }}
              />
              <Button
                variant="contained"
                size="medium"
                sx={{
                  backgroundColor: "#4285f4",
                  color: "#fff",
                  fontWeight: 600,
                  fontFamily: "Poppins, sans-serif",
                  "&:hover": {
                    backgroundColor: "#1b449e",
                  },
                }}
              >
                Subscribe
              </Button>
            </Box>
          </Grid>
          */}
        </Grid>

        {/* ✅ Bottom Section */}
        <Box textAlign="center" mt={2}>
          <Typography variant="body2">
            © {new Date().getFullYear()} AutoShops.com. All rights reserved.
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            <MuiLink
              component={RouterLink}
              to="/PrivacyPolicy"
              color="inherit"
              underline="hover"
              sx={{ mx: 1 }}
            >
              Privacy Policy
            </MuiLink>
            |
            <MuiLink
              component={RouterLink}
              to="/tos"
              color="inherit"
              underline="hover"
              sx={{ mx: 1 }}
            >
              Terms of Service
            </MuiLink>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
